/** Auto-generated taxonomy display labels (FR canonical → EN / NL). */
export const TAXONOMY_LABELS = {
  'Abrasifs': { en: 'Abrasives', nl: 'Schuurmiddelen' },
  'Abreuvoirs': { en: 'Drinkers', nl: 'Drinkbakken' },
  'Accessoires': { en: 'Accessories', nl: 'Accessoires' },
  'Accessoires agricoles': { en: 'Agricultural accessories', nl: 'Landbouwaccessoires' },
  'Accessoires de chantier': { en: 'Site accessories', nl: 'Bouwplaatsaccessoires' },
  'Accessoires de microtracteurs': { en: 'Compact tractor accessories', nl: 'Microtractoraccessoires' },
  'Accessoires de soudage': { en: 'Welding accessories', nl: 'Lasaccessoires' },
  'Accessoires divers': { en: 'Miscellaneous accessories', nl: 'Diverse accessoires' },
  'Accès': { en: 'Access', nl: 'Toegang' },
  'Acier / profilés': { en: 'Steel / profiles', nl: 'Staal / profielen' },
  'Adaptateurs': { en: 'Adapters', nl: 'Adapters' },
  'Agrafeuses': { en: 'Staplers', nl: 'Nietmachines' },
  'Agrafeuses pneumatiques': { en: 'Pneumatic staplers', nl: 'Pneumatische nietmachines' },
  'Aiguilles vibrantes': { en: 'Poker vibrators', nl: 'Trilnaalden' },
  'Air comprimé': { en: 'Compressed air', nl: 'Perslucht' },
  'Andaineurs': { en: 'Windrowers / rakes', nl: 'Harken / zwadharken' },
  'Arboriculture': { en: 'Orchard farming', nl: 'Fruitteelt' },
  'Armoires à outils': { en: 'Tool cabinets', nl: 'Gereedschapskasten' },
  'Arracheuses': { en: 'Diggers / lifters', nl: 'Rooiders' },
  'Arrosage': { en: 'Watering', nl: 'Besproeiing' },
  'Aspirateurs de feuilles': { en: 'Leaf vacuums', nl: 'Bladzuigers' },
  'Aspirateurs eau et poussière': { en: 'Wet & dry vacuums', nl: 'Nat-/droogstofzuigers' },
  'Aspirateurs industriels': { en: 'Industrial vacuums', nl: 'Industriële stofzuigers' },
  'Atelier': { en: 'Workshop', nl: 'Werkplaats' },
  'Atomiseurs': { en: 'Air-blast sprayers', nl: 'Atomiseurs' },
  'Attelages': { en: 'Hitches', nl: 'Aankoppelingen' },
  'Autolaveuses': { en: 'Floor scrubbers', nl: 'Schrobmachines' },
  'Autoportées': { en: 'Zero-turn / ride-ons', nl: 'Zelfrijdende maaiers' },
  'Autres conteneurs': { en: 'Other containers', nl: 'Overige containers' },
  'Autres matériaux': { en: 'Other materials', nl: 'Overige materialen' },
  'Autres matériels agricoles': { en: 'Other farm equipment', nl: 'Overig landbouwmaterieel' },
  'Autres matériels BTP': { en: 'Other construction equipment', nl: 'Overig bouwmaterieel' },
  'Autres matériels espaces verts': { en: 'Other green-space equipment', nl: 'Overig groenmaterieel' },
  'Autres outillages professionnels': { en: 'Other professional tools', nl: 'Overig professioneel gereedschap' },
  'Aérateurs': { en: 'Aerators', nl: 'Beluchters' },
  'Balais mécaniques': { en: 'Mechanical sweepers', nl: 'Mechanische bezems' },
  'Balayeuses': { en: 'Sweepers', nl: 'Veegmachines' },
  'Balayeuses de voirie': { en: 'Street sweepers', nl: 'Veegmachines' },
  'Barrières': { en: 'Barriers', nl: 'Afzettingen' },
  'Batteries': { en: 'Batteries', nl: 'Accu\'s' },
  'Batteries professionnelles': { en: 'Professional batteries', nl: 'Professionele accu\'s' },
  'Benne de chantier': { en: 'Site skip', nl: 'Bouwcontainer' },
  'Bennes': { en: 'Tipper bodies / skips', nl: 'Kipbakken' },
  'Bennes agricoles': { en: 'Farm tippers', nl: 'Landbouwkippers' },
  'Bois': { en: 'Wood & forestry', nl: 'Hout & bosbouw' },
  'Bois & métaux': { en: 'Timber & metals', nl: 'Hout & metalen' },
  'Bois de construction': { en: 'Construction timber', nl: 'Constructiehout' },
  'Bordures': { en: 'Kerbs', nl: 'Boordstenen' },
  'Boulonneuses': { en: 'Impact wrenches', nl: 'Slagmoersleutels' },
  'Briques': { en: 'Bricks', nl: 'Bakstenen' },
  'Brise-béton': { en: 'Concrete breakers', nl: 'Betonbrekers' },
  'Brouettes motorisées': { en: 'Powered wheelbarrows', nl: 'Motorische kruiwagens' },
  'Broyeurs': { en: 'Crushers', nl: 'Brekers' },
  'Broyeurs arboricoles': { en: 'Orchard mulchers', nl: 'Fruitteeltklepelmaaiers' },
  'Broyeurs de branches': { en: 'Branch chippers', nl: 'Takkenversnipperaars' },
  'Broyeurs de sarments': { en: 'Vine shoot shredders', nl: 'Snoeihoutversnipperaars' },
  'Broyeurs de végétaux': { en: 'Garden shredders', nl: 'Hakselaars' },
  'Bulldozers': { en: 'Bulldozers', nl: 'Bulldozers' },
  'Bungalows': { en: 'Site cabins', nl: 'Keetwagens' },
  'Burineurs': { en: 'Chipping hammers', nl: 'Beitelhamers' },
  'Burins': { en: 'Chisels', nl: 'Beitels' },
  'Béton': { en: 'Concrete', nl: 'Beton' },
  'Béton & Maçonnerie': { en: 'Concrete & masonry', nl: 'Beton & metselwerk' },
  'Bétonnières': { en: 'Concrete mixers', nl: 'Betonmolens' },
  'Caisses à outils': { en: 'Toolboxes', nl: 'Gereedschapskisten' },
  'Caissons': { en: 'Box bodies', nl: 'Bakken' },
  'Caniveaux': { en: 'Gutters / channels', nl: 'Goten' },
  'Canons d\'arrosage': { en: 'Irrigation guns', nl: 'Beregeningskanonnen' },
  'Cardans': { en: 'PTO shafts', nl: 'Aftakassen' },
  'Chalumeaux': { en: 'Torches', nl: 'Branders' },
  'Chandelles': { en: 'Axle stands', nl: 'Assteunen' },
  'Chargeurs': { en: 'Chargers', nl: 'Laders' },
  'Chargeurs de batteries': { en: 'Battery chargers', nl: 'Acculaders' },
  'Chargeurs frontaux': { en: 'Front loaders', nl: 'Voorladers' },
  'Chargeuses': { en: 'Loaders', nl: 'Wielladers' },
  'Chargeuses compactes': { en: 'Compact loaders', nl: 'Compacte wielladers' },
  'Chariots de transport': { en: 'Transport trolleys', nl: 'Transportwagens' },
  'Chariots télescopiques': { en: 'Telehandlers', nl: 'Verreikers' },
  'Chariots élévateurs': { en: 'Forklifts', nl: 'Heftrucks' },
  'Chariots élévateurs agricoles': { en: 'Agricultural forklifts', nl: 'Landbouwheftrucks' },
  'Charrues': { en: 'Ploughs', nl: 'Ploegen' },
  'Chaux': { en: 'Lime', nl: 'Kalk' },
  'Chaînes': { en: 'Chains', nl: 'Kettingen' },
  'Chèvres de levage': { en: 'Engine cranes', nl: 'Motorkranen' },
  'Ciment': { en: 'Cement', nl: 'Cement' },
  'Ciseaux à bois': { en: 'Wood chisels', nl: 'Houtbeitels' },
  'Cloueurs': { en: 'Nailers', nl: 'Spijkermachines' },
  'Cloueurs pneumatiques': { en: 'Pneumatic nailers', nl: 'Pneumatische spijkermachines' },
  'Clés plates': { en: 'Open-end wrenches', nl: 'Steeksleutels' },
  'Clés à choc': { en: 'Impact wrenches', nl: 'Slagsleutels' },
  'Clés à choc pneumatiques': { en: 'Pneumatic impact wrenches', nl: 'Pneumatische slagsleutels' },
  'Clés à cliquet': { en: 'Ratchet wrenches', nl: 'Ratelsleutels' },
  'Clôtures': { en: 'Fencing', nl: 'Omheiningen' },
  'Clôtures de chantier': { en: 'Site fencing', nl: 'Bouwhekken' },
  'Clôtures électriques': { en: 'Electric fencing', nl: 'Schrikdraad' },
  'Coffrage': { en: 'Formwork', nl: 'Bekisting' },
  'Coffrets d\'outils': { en: 'Tool kits', nl: 'Gereedschapssets' },
  'Compactage': { en: 'Compaction', nl: 'Verdichting' },
  'Compacteurs': { en: 'Compactors', nl: 'Verdichtingsmachines' },
  'Compresseurs': { en: 'Compressors', nl: 'Compressoren' },
  'Concassé': { en: 'Crushed stone', nl: 'Steenslag' },
  'Consommables': { en: 'Consumables', nl: 'Verbruiksgoederen' },
  'Containers': { en: 'Containers', nl: 'Containers' },
  'Conteneur 10 m³': { en: '10 m³ container', nl: 'Container 10 m³' },
  'Conteneur 15 m³': { en: '15 m³ container', nl: 'Container 15 m³' },
  'Conteneur 20 m³': { en: '20 m³ container', nl: 'Container 20 m³' },
  'Conteneur 30 m³': { en: '30 m³ container', nl: 'Container 30 m³' },
  'Conteneur 5 m³': { en: '5 m³ container', nl: 'Container 5 m³' },
  'Conteneur bois': { en: 'Wood container', nl: 'Houtcontainer' },
  'Conteneur déchets verts': { en: 'Green waste container', nl: 'GFT-container' },
  'Conteneur métaux': { en: 'Metal container', nl: 'Metaalcontainer' },
  'Conteneur à gravats': { en: 'Rubble container', nl: 'Puincontainer' },
  'Contrepoids': { en: 'Counterweights', nl: 'Tegengewichten' },
  'Convertisseurs': { en: 'Converters', nl: 'Omvormers' },
  'Cornadis': { en: 'Feed barriers / headlocks', nl: 'Voerhekken' },
  'Coupe-bordures': { en: 'String trimmers', nl: 'Kantenmaaiers' },
  'Coupe-boulons': { en: 'Bolt cutters', nl: 'Boutenschaar' },
  'Coupe-briques': { en: 'Brick cutters', nl: 'Steensnijders' },
  'Coupe-carreaux': { en: 'Tile cutters', nl: 'Tegelsnijders' },
  'Cover-crops': { en: 'Cover-crop tools', nl: 'Cover-crop werktuigen' },
  'Crics': { en: 'Jacks', nl: 'Krikken' },
  'Cueilleuses': { en: 'Pickers', nl: 'Plukmachines' },
  'Cultivateurs': { en: 'Cultivators', nl: 'Cultivators' },
  'Dalles': { en: 'Slabs', nl: 'Tegels / platen' },
  'Dessoucheuses': { en: 'Stump removers', nl: 'Stronkverwijderaars' },
  'Disques': { en: 'Discs', nl: 'Schijven' },
  'Distributeurs d\'aliments': { en: 'Feed dispensers', nl: 'Voederverdelers' },
  'Divers': { en: 'Miscellaneous', nl: 'Diversen' },
  'Douilles': { en: 'Sockets', nl: 'Dopsleutels' },
  'Dumpers': { en: 'Dumpers', nl: 'Dumpers' },
  'Débroussaillage': { en: 'Brush clearing', nl: 'Maaien & struikgewas' },
  'Débroussailleuses': { en: 'Brush cutters', nl: 'Bosmaaiers' },
  'Débroussailleuses à roues': { en: 'Wheeled brush cutters', nl: 'Wielmaaiers' },
  'Décapeurs thermiques': { en: 'Heat guns', nl: 'Heteluchtpistolen' },
  'Déchaumeurs': { en: 'Stubble cultivators', nl: 'Stoppelcultivators' },
  'Déchiqueteuses': { en: 'Chippers', nl: 'Versnipperaars' },
  'Décompacteurs': { en: 'Subsoilers / decompactors', nl: 'Diepwoelers' },
  'Découpe plasma': { en: 'Plasma cutters', nl: 'Plasmasnijders' },
  'Défonceuses': { en: 'Routers', nl: 'Bovenfrezen' },
  'Démolition': { en: 'Demolition', nl: 'Sloop' },
  'Démonte-pneus': { en: 'Tyre changers', nl: 'Bandenmonteermachines' },
  'Dérouleurs de grillage': { en: 'Fence unrollers', nl: 'Gaasafrollers' },
  'Déshumidificateurs': { en: 'Dehumidifiers', nl: 'Ontvochtigers' },
  'Désileuses': { en: 'Silage cutters / feeders', nl: 'Kuilsnijders' },
  'Dévidoirs': { en: 'Hose reels', nl: 'Slanghaspels' },
  'Embouts': { en: 'Driver bits', nl: 'Bits' },
  'Enfonce-pieux': { en: 'Post drivers', nl: 'Paalhamers' },
  'Enjambeurs': { en: 'Straddle tractors', nl: 'Wijnbouwtrekkers (enjambeurs)' },
  'Enrouleurs': { en: 'Reels', nl: 'Haspels' },
  'Enrouleurs d\'air': { en: 'Air hose reels', nl: 'Luchtslanghaspels' },
  'Enrouleurs d\'irrigation': { en: 'Irrigation reels', nl: 'Beregeningshaspels' },
  'Enrouleurs électriques': { en: 'Cable reels', nl: 'Kabelhaspels' },
  'Enrubanneuses': { en: 'Bale wrappers', nl: 'Wikkelaars' },
  'Ensileuses': { en: 'Forage harvesters', nl: 'Hakselaars' },
  'Escabeaux': { en: 'Step ladders', nl: 'Trapladders' },
  'Faneuses': { en: 'Tedders', nl: 'Schudders' },
  'Faucheuses': { en: 'Mowers', nl: 'Maaimachines' },
  'Faucheuses-conditionneuses': { en: 'Mower-conditioners', nl: 'Maai-kneuzers' },
  'Faux et débroussailleuses professionnelles': { en: 'Professional scythes & brush cutters', nl: 'Professionele zeisen & bosmaaiers' },
  'Fenaison': { en: 'Haymaking', nl: 'Hooien' },
  'Fendeuses': { en: 'Log splitters', nl: 'Houtklovers' },
  'Fendeuses à bois': { en: 'Log splitters', nl: 'Houtklovers' },
  'Ferraillage': { en: 'Rebar', nl: 'Wapening' },
  'Fertilisation': { en: 'Fertilisation', nl: 'Bemesting' },
  'Finisseurs': { en: 'Asphalt pavers', nl: 'Asfaltspreidmachines' },
  'Forets': { en: 'Drill bits', nl: 'Boortjes' },
  'Forêt & Bois': { en: 'Forestry & wood', nl: 'Bosbouw & hout' },
  'Fourches': { en: 'Forks', nl: 'Vorken' },
  'Fraises rotatives': { en: 'Rotary tillers', nl: 'Rotorkopeggen' },
  'Gerbeurs': { en: 'Stackers', nl: 'Stapelaars' },
  'Godets': { en: 'Buckets', nl: 'Bakken' },
  'Godets et fourches': { en: 'Buckets and forks', nl: 'Bakken en vorken' },
  'Granulats & béton': { en: 'Aggregates & concrete', nl: 'Aggregaten & beton' },
  'Grappins': { en: 'Grapples', nl: 'Grijpers' },
  'Gravier': { en: 'Gravel', nl: 'Grind' },
  'Groupes de surpression': { en: 'Booster pumps', nl: 'Drukverhogingssets' },
  'Groupes électrogènes': { en: 'Generators', nl: 'Aggregaten' },
  'Grues mobiles': { en: 'Mobile cranes', nl: 'Mobiele kranen' },
  'Générateurs': { en: 'Generators', nl: 'Aggregaten' },
  'Générateurs d\'air': { en: 'Air generators', nl: 'Luchtaggregaten' },
  'Herses': { en: 'Harrows', nl: 'Eggen' },
  'Herses rotatives': { en: 'Power harrows', nl: 'Rotoreggen' },
  'Herses à disques': { en: 'Disc harrows', nl: 'Schijveneggen' },
  'Injecteurs à lisier': { en: 'Slurry injectors', nl: 'Mestinjecteurs' },
  'Irrigation': { en: 'Irrigation', nl: 'Irrigatie' },
  'Isolation': { en: 'Insulation', nl: 'Isolatie' },
  'Jantes': { en: 'Rims', nl: 'Velgen' },
  'Jardin & Extérieur': { en: 'Garden & outdoor', nl: 'Tuin & buiten' },
  'Jardin, terrasse & extérieur': { en: 'Garden, terrace & outdoor', nl: 'Tuin, terras & buiten' },
  'Jeux de clés': { en: 'Wrench sets', nl: 'Steeksleutelsets' },
  'Lames': { en: 'Blades', nl: 'Messen' },
  'Lampes de chantier': { en: 'Work lights', nl: 'Bouwlampen' },
  'Lasers lignes': { en: 'Line lasers', nl: 'Lijnlasers' },
  'Lasers rotatifs': { en: 'Rotary lasers', nl: 'Rotatielasers' },
  'Levage': { en: 'Lifting', nl: 'Hefmaterieel' },
  'Levage & Manutention': { en: 'Lifting & handling', nl: 'Hef- & handlingmaterieel' },
  'Limes': { en: 'Files', nl: 'Vijlen' },
  'Livraison & enlèvement': { en: 'Delivery & collection', nl: 'Levering & ophaling' },
  'Location de conteneur': { en: 'Container rental', nl: 'Containervoorhuur' },
  'Logettes': { en: 'Cubicles', nl: 'Ligboxen' },
  'Lot / surplus chantier': { en: 'Job lot / surplus', nl: 'Restpartij / surplus' },
  'Lots d\'outillage': { en: 'Tool lots', nl: 'Gereedschapspartijen' },
  'Lots de matériel': { en: 'Equipment lots', nl: 'Materieelpartijen' },
  'Lots de matériel agricole': { en: 'Farm equipment lots', nl: 'Landbouwpartijen' },
  'Machines agricoles': { en: 'Farm machines', nl: 'Landbouwmachines' },
  'Malaxeurs': { en: 'Mixers', nl: 'Mengmachines' },
  'Manutention': { en: 'Handling', nl: 'Handling' },
  'Marteaux': { en: 'Hammers', nl: 'Hamers' },
  'Marteaux de démolition': { en: 'Demolition hammers', nl: 'Sloophamers' },
  'Marteaux perforateurs': { en: 'Hammer drills', nl: 'Klopboormachines' },
  'Marteaux-piqueurs': { en: 'Jackhammers', nl: 'Breekhamers' },
  'Masses': { en: 'Weights', nl: 'Gewichten' },
  'Massettes': { en: 'Mallets / club hammers', nl: 'Knotshamers' },
  'Matériaux & fournitures métier': { en: 'Trade materials & supplies', nl: 'Vakmaterialen & leveringen' },
  'Matériel d\'irrigation': { en: 'Irrigation equipment', nl: 'Irrigatiematerieel' },
  'Matériel d\'occasion': { en: 'Used equipment', nl: 'Tweedehands materieel' },
  'Matériel d\'élevage': { en: 'Livestock equipment', nl: 'Veeteeltmaterieel' },
  'Matériel de pavage': { en: 'Paving equipment', nl: 'Bestratingsmaterieel' },
  'Matériel de traite': { en: 'Milking equipment', nl: 'Melkmaterieel' },
  'Maçonnerie & voirie': { en: 'Masonry & paving', nl: 'Metselwerk & bestrating' },
  'Mesure': { en: 'Measuring', nl: 'Meten' },
  'Mesure & Laser': { en: 'Surveying & laser', nl: 'Meten & laser' },
  'Meuleuses': { en: 'Angle grinders', nl: 'Haakse slijpers' },
  'Meuleuses pneumatiques': { en: 'Pneumatic grinders', nl: 'Pneumatische slijpers' },
  'Microtracteurs': { en: 'Compact garden tractors', nl: 'Microtractoren' },
  'Mini-grues': { en: 'Mini cranes', nl: 'Minikranen' },
  'Mini-pelles': { en: 'Mini excavators', nl: 'Minigravers' },
  'Modules & Chantier': { en: 'Site modules', nl: 'Bouwplaatsmodules' },
  'Moissonneuses-batteuses': { en: 'Combine harvesters', nl: 'Maaidorsers' },
  'Mortier': { en: 'Mortar', nl: 'Mortel' },
  'Motobineuses': { en: 'Power tillers', nl: 'Tuinfrezen' },
  'Motoculteurs': { en: 'Cultivators / tillers', nl: 'Frezen / tuinfrezen' },
  'Motopompes': { en: 'Engine pumps', nl: 'Motorpompen' },
  'Multifonctions oscillants': { en: 'Oscillating multi-tools', nl: 'Oscillerende multitools' },
  'Mèches': { en: 'Bits / augers', nl: 'Beitels / boren' },
  'Mètres': { en: 'Tape measures', nl: 'Rolmeters' },
  'Mélangeuses': { en: 'Feed mixers', nl: 'Voedermengers' },
  'Nacelles': { en: 'Aerial platforms', nl: 'Hoogwerkers' },
  'Nacelles articulées': { en: 'Articulated boom lifts', nl: 'Knikarmhoogwerkers' },
  'Nacelles ciseaux': { en: 'Scissor lifts', nl: 'Schaarhoogwerkers' },
  'Nacelles télescopiques': { en: 'Telescopic boom lifts', nl: 'Telescoophoogwerkers' },
  'Nettoyage': { en: 'Cleaning', nl: 'Reiniging' },
  'Nettoyeurs haute pression': { en: 'Pressure washers', nl: 'Hogedrukreinigers' },
  'Niveaux': { en: 'Levels', nl: 'Waterpassen' },
  'Niveaux laser': { en: 'Laser levels', nl: 'Laserniveaus' },
  'Niveleuses': { en: 'Graders', nl: 'Wegenbouwschaven' },
  'Outillage d\'atelier': { en: 'Workshop tools', nl: 'Werkplaatsgereedschap' },
  'Outillage pneumatique': { en: 'Pneumatic tools', nl: 'Pneumatisch gereedschap' },
  'Outillage à main': { en: 'Hand tools', nl: 'Handgereedschap' },
  'Outillage électroportatif': { en: 'Power tools', nl: 'Elektrisch gereedschap' },
  'Palans': { en: 'Hoists', nl: 'Takels' },
  'Panneaux (OSB, CTB…)': { en: 'Panels (OSB, plywood…)', nl: 'Panelen (OSB, multiplex…)' },
  'Parpaings / blocs': { en: 'Concrete blocks', nl: 'Blokken' },
  'Pavés': { en: 'Paving stones', nl: 'Klinkers' },
  'Paysagisme': { en: 'Landscaping', nl: 'Landschapsaanleg' },
  'Peinture & finition': { en: 'Paint & finishing', nl: 'Verf & afwerking' },
  'Pelles hydrauliques': { en: 'Hydraulic excavators', nl: 'Hydraulische graafmachines' },
  'Pelleteuses': { en: 'Excavators', nl: 'Graafmachines' },
  'Pelouse': { en: 'Lawn care', nl: 'Gazonzorg' },
  'Perceuses': { en: 'Drills', nl: 'Boormachines' },
  'Perceuses à colonne': { en: 'Drill presses', nl: 'Kolomboormachines' },
  'Perceuses à percussion': { en: 'Hammer drills', nl: 'Klopboormachines' },
  'Perforateurs': { en: 'Rotary hammers', nl: 'Boorhamers' },
  'Pilonneuses': { en: 'Tamping rammers', nl: 'Trilstampers' },
  'Pinces': { en: 'Pliers', nl: 'Tangens' },
  'Pinces de démolition': { en: 'Demolition shears', nl: 'Sloopscharen' },
  'Pinces à balles': { en: 'Bale grabs', nl: 'Balenklemmen' },
  'Pièces & Accessoires': { en: 'Parts & accessories', nl: 'Onderdelen & accessoires' },
  'Pièces détachées': { en: 'Spare parts', nl: 'Reservonderdelen' },
  'Plantation': { en: 'Planting', nl: 'Planten' },
  'Planteuses': { en: 'Planters', nl: 'Plantmachines' },
  'Plaques vibrantes': { en: 'Plate compactors', nl: 'Trilplaten' },
  'Plateaux': { en: 'Flatbeds', nl: 'Plateaus' },
  'Plateformes de récolte': { en: 'Harvest platforms', nl: 'Oogstplatforms' },
  'Plates-formes': { en: 'Work platforms', nl: 'Werkplatforms' },
  'Plates-formes roulantes': { en: 'Rolling platforms', nl: 'Rolsteigers' },
  'Plomberie (matériel)': { en: 'Plumbing supplies', nl: 'Loodgietersmateriaal' },
  'Plâtre / plaques': { en: 'Plaster / plasterboard', nl: 'Gips / gipsplaten' },
  'Pneus': { en: 'Tyres', nl: 'Banden' },
  'Pneus agricoles': { en: 'Agricultural tyres', nl: 'Landbouwbanden' },
  'Polisseuses': { en: 'Polishers', nl: 'Polijstmachines' },
  'Pompes': { en: 'Pumps', nl: 'Pompen' },
  'Pompes à eau': { en: 'Water pumps', nl: 'Waterpompen' },
  'Ponceuses': { en: 'Sanders', nl: 'Schuurmachines' },
  'Ponceuses pneumatiques': { en: 'Pneumatic sanders', nl: 'Pneumatische schuurmachines' },
  'Porte-engins': { en: 'Plant trailers', nl: 'Machineaanhangers' },
  'Porte-outils': { en: 'Tool carriers', nl: 'Werktuigdragers' },
  'Porte-outils agricoles': { en: 'Agricultural tool carriers', nl: 'Landbouw werktuigdragers' },
  'Postes MIG': { en: 'MIG welders', nl: 'MIG-lasapparaten' },
  'Postes MMA': { en: 'Stick welders', nl: 'Elektrode-lasapparaten' },
  'Postes TIG': { en: 'TIG welders', nl: 'TIG-lasapparaten' },
  'Postes à souder': { en: 'Welders', nl: 'Lasapparaten' },
  'Postes à souder MIG': { en: 'MIG welders', nl: 'MIG-lasapparaten' },
  'Postes à souder MMA': { en: 'Stick (MMA) welders', nl: 'Elektrode-lasapparaten' },
  'Postes à souder TIG': { en: 'TIG welders', nl: 'TIG-lasapparaten' },
  'Presses': { en: 'Balers', nl: 'Persen' },
  'Presses carrées': { en: 'Square balers', nl: 'Vierkante balenpersen' },
  'Presses hydrauliques': { en: 'Hydraulic presses', nl: 'Hydraulische persen' },
  'Presses rondes': { en: 'Round balers', nl: 'Ronde balenpersen' },
  'Projecteurs LED': { en: 'LED floodlights', nl: 'LED-bouwlampen' },
  'Pulvérisateurs': { en: 'Sprayers', nl: 'Spuitmachines' },
  'Pulvérisateurs arboricoles': { en: 'Orchard sprayers', nl: 'Fruitspuiten' },
  'Pulvérisateurs automoteurs': { en: 'Self-propelled sprayers', nl: 'Zelfrijdende spuiten' },
  'Pulvérisateurs portés': { en: 'Mounted sprayers', nl: 'Gedragen spuiten' },
  'Pulvérisateurs traînés': { en: 'Trailed sprayers', nl: 'Getrokken spuiten' },
  'Pulvérisateurs viticoles': { en: 'Vineyard sprayers', nl: 'Wijnbouwspuiten' },
  'Quads': { en: 'ATVs / quads', nl: 'Quads' },
  'Quincaillerie': { en: 'Hardware', nl: 'Ijzerwaren' },
  'Raboteuses': { en: 'Planers / cold millers', nl: 'Frezen / schaafmachines' },
  'Rabots électriques': { en: 'Electric planers', nl: 'Elektrische schaven' },
  'Rainureuses': { en: 'Wall chasers', nl: 'Sleuvenfrezen' },
  'Rallonges': { en: 'Extension cords', nl: 'Verlengkabels' },
  'Ramasseuses': { en: 'Collectors / pick-ups', nl: 'Opraapmachines' },
  'Rampes d\'irrigation': { en: 'Irrigation booms', nl: 'Beregeningsbomen' },
  'Rangements': { en: 'Storage', nl: 'Opberging' },
  'Remorques': { en: 'Trailers', nl: 'Aanhangers' },
  'Remorques agricoles': { en: 'Farm trailers', nl: 'Landbouwaanhangers' },
  'Remorques basculantes': { en: 'Tipping trailers', nl: 'Kipaanhangers' },
  'Remorques de chantier': { en: 'Site trailers', nl: 'Bouwaanhangers' },
  'Repiqueuses': { en: 'Transplanters', nl: 'Plantmachines' },
  'Riders': { en: 'Ride-on mowers', nl: 'Zitmaaiers' },
  'Riveteuses': { en: 'Rivet guns', nl: 'Klinknagelaars' },
  'Robots de tonte': { en: 'Robotic mowers', nl: 'Robotmaaiers' },
  'Rogneuses': { en: 'Trimmers / toppers', nl: 'Snoeimachines' },
  'Rogneuses de souches': { en: 'Stump grinders', nl: 'Stronkfrezen' },
  'Roues': { en: 'Wheels', nl: 'Wielen' },
  'Rouleaux agricoles': { en: 'Farm rollers', nl: 'Landbouwrollen' },
  'Rouleaux compresseurs': { en: 'Road rollers', nl: 'Wegenwalsen' },
  'Rouleaux à gazon': { en: 'Lawn rollers', nl: 'Gazonzrollers' },
  'Récolte': { en: 'Harvesting', nl: 'Oogst' },
  'Récolteuses de betteraves': { en: 'Beet harvesters', nl: 'Bietenrooiers' },
  'Récolteuses de pommes de terre': { en: 'Potato harvesters', nl: 'Aardappelrooiers' },
  'Sable': { en: 'Sand', nl: 'Zand' },
  'Saleuses': { en: 'Salt spreaders', nl: 'Strooiers' },
  'Scarificateurs': { en: 'Scarifiers', nl: 'Verticuteermachines' },
  'Scies circulaires': { en: 'Circular saws', nl: 'Cirkelzagen' },
  'Scies de sol': { en: 'Floor saws', nl: 'Vloerzagen' },
  'Scies manuelles': { en: 'Hand saws', nl: 'Handzagen' },
  'Scies sabres': { en: 'Reciprocating saws', nl: 'Reciprozaagmachines' },
  'Scies sauteuses': { en: 'Jigsaws', nl: 'Decoupeerzagen' },
  'Scies sur table': { en: 'Table saws', nl: 'Tafelzagen' },
  'Scies à bûches': { en: 'Log saws', nl: 'Blokzagen' },
  'Scies à matériaux': { en: 'Masonry saws', nl: 'Materiaalzagen' },
  'Scies à onglet': { en: 'Mitre saws', nl: 'Afkortzagen' },
  'Scies à ruban': { en: 'Band saws', nl: 'Lintzagen' },
  'Scies à ruban d\'atelier': { en: 'Workshop band saws', nl: 'Werkplaatslintzagen' },
  'Second œuvre & divers': { en: 'Finishing & other', nl: 'Afwerking & overig' },
  'Semis': { en: 'Seeding', nl: 'Zaaien' },
  'Semoirs': { en: 'Seed drills', nl: 'Zaaimachines' },
  'Serre-joints': { en: 'Clamps', nl: 'Lijmklemmen' },
  'Servantes d\'atelier': { en: 'Tool cabinets / trolleys', nl: 'Gereedschapswagens' },
  'Signalisation': { en: 'Signage', nl: 'Signalering' },
  'Soudage': { en: 'Welding', nl: 'Lassen' },
  'Soufflettes': { en: 'Blow guns', nl: 'Blaaspistolen' },
  'Souffleurs': { en: 'Blowers', nl: 'Bladblazers' },
  'Sous-soleuses': { en: 'Subsoilers', nl: 'Woelers' },
  'Stations totales': { en: 'Total stations', nl: 'Total stations' },
  'Sécateurs électriques': { en: 'Electric pruners', nl: 'Elektrische snoeischaren' },
  'Sécurité': { en: 'Safety', nl: 'Veiligheid' },
  'Taille': { en: 'Pruning & trimming', nl: 'Snoeien' },
  'Taille-haies': { en: 'Hedge trimmers', nl: 'Heggenscharen' },
  'Taille-haies sur perche': { en: 'Pole hedge trimmers', nl: 'Stokheggenscharen' },
  'Tailleuses': { en: 'Pruning machines', nl: 'Snoeimachines' },
  'Tanks à lait': { en: 'Milk tanks', nl: 'Melktanks' },
  'Tarières': { en: 'Earth augers', nl: 'Grondboren' },
  'Tarières hydrauliques': { en: 'Hydraulic augers', nl: 'Hydraulische grondboren' },
  'Terrassement': { en: 'Earthmoving', nl: 'Grondwerken' },
  'Terre / remblai': { en: 'Soil / fill', nl: 'Grond / aanvulling' },
  'Théodolites': { en: 'Theodolites', nl: 'Theodolieten' },
  'Tombereaux': { en: 'Dump trucks', nl: 'Kipwagens' },
  'Tondeuses': { en: 'Lawn mowers', nl: 'Grasmaaiers' },
  'Tondeuses thermiques': { en: 'Petrol mowers', nl: 'Benzinemaaiers' },
  'Tondeuses à batterie': { en: 'Battery mowers', nl: 'Accumaaiers' },
  'Tondeuses électriques': { en: 'Electric mowers', nl: 'Elektrische maaiers' },
  'Tonnes à lisier': { en: 'Slurry tankers', nl: 'Mesttanks' },
  'Tonte': { en: 'Mowing', nl: 'Maaien' },
  'Tourets à meuler': { en: 'Bench grinders', nl: 'Slijpmachines' },
  'Tournevis': { en: 'Screwdrivers', nl: 'Schroevendraaiers' },
  'Tours d\'éclairage': { en: 'Light towers', nl: 'Lichtmasten' },
  'Tracteurs': { en: 'Tractors', nl: 'Tractoren' },
  'Tracteurs agricoles': { en: 'Farm tractors', nl: 'Landbouwtractoren' },
  'Tracteurs chenillés': { en: 'Tracked tractors', nl: 'Rupstractoren' },
  'Tracteurs compacts': { en: 'Compact tractors', nl: 'Compacte tractoren' },
  'Tracteurs fruitiers': { en: 'Orchard tractors', nl: 'Fruitteelttractoren' },
  'Tracteurs tondeuses': { en: 'Lawn tractors', nl: 'Zitmaaiers / trekkers' },
  'Tracteurs vignerons': { en: 'Vineyard tractors', nl: 'Wijnbouwtractoren' },
  'Tractopelles': { en: 'Backhoe loaders', nl: 'Graaflaadcombinaties' },
  'Traitement': { en: 'Crop protection', nl: 'Gewasbescherming' },
  'Transformateurs': { en: 'Transformers', nl: 'Transformatoren' },
  'Transpalettes': { en: 'Pallet trucks', nl: 'Palletwagens' },
  'Transport': { en: 'Transport', nl: 'Transport' },
  'Transporteurs à chenilles': { en: 'Tracked carriers', nl: 'Rupstransporters' },
  'Travail du sol': { en: 'Soil working', nl: 'Grondbewerking' },
  'Travaux routiers': { en: 'Road works', nl: 'Wegenwerken' },
  'Treuils': { en: 'Winches', nl: 'Lieren' },
  'Treuils forestiers': { en: 'Forestry winches', nl: 'Bosbouwlieren' },
  'Tronçonneuses': { en: 'Chainsaws', nl: 'Kettingzagen' },
  'Tronçonneuses d\'élagage': { en: 'Pruning chainsaws', nl: 'Snoeikettingzagen' },
  'Tuyaux d\'irrigation': { en: 'Irrigation hoses', nl: 'Beregeningsslangen' },
  'Télescopiques agricoles': { en: 'Agricultural telehandlers', nl: 'Landbouwverreikers' },
  'Télémètres': { en: 'Laser rangefinders', nl: 'Afstandmeters' },
  'Tôles': { en: 'Sheet metal', nl: 'Plaatstaal' },
  'Ventilation': { en: 'Ventilation', nl: 'Ventilatie' },
  'Vibrateurs à béton': { en: 'Concrete vibrators', nl: 'Betontrilnaalden' },
  'Visseuses': { en: 'Screwdrivers / drivers', nl: 'Schroefmachines' },
  'Viticulture': { en: 'Viticulture', nl: 'Wijnbouw' },
  'Véhicules espaces verts': { en: 'Green space vehicles', nl: 'Groenvoertuigen' },
  'Véhicules utilitaires': { en: 'Utility vehicles', nl: 'Bedrijfsvoertuigen' },
  'Vérins hydrauliques': { en: 'Hydraulic jacks', nl: 'Hydraulische krikken' },
  'WC de chantier': { en: 'Site toilets', nl: 'Bouwtoiletten' },
  'Échafaudage & Accès': { en: 'Scaffolding & access', nl: 'Steigers & toegang' },
  'Échafaudages': { en: 'Scaffolding', nl: 'Steigers' },
  'Échelles': { en: 'Ladders', nl: 'Ladders' },
  'Échelles & échafaudages': { en: 'Ladders & scaffolding', nl: 'Ladders & steigers' },
  'Éclairage': { en: 'Lighting', nl: 'Verlichting' },
  'Élagueuses': { en: 'Pruning saws', nl: 'Snoeizagen' },
  'Élagueuses sur perche': { en: 'Pole saws', nl: 'Stokkettingzagen' },
  'Électricité': { en: 'Electrical', nl: 'Elektriciteit' },
  'Électricité (matériel)': { en: 'Electrical supplies', nl: 'Elektriciteitsmateriaal' },
  'Électroportatif': { en: 'Power tools', nl: 'Elektrisch gereedschap' },
  'Élevage': { en: 'Livestock', nl: 'Veeteelt' },
  'Énergie': { en: 'Power', nl: 'Energie' },
  'Épampreuses': { en: 'Leaf removers', nl: 'Bladverwijderaars' },
  'Épandeurs': { en: 'Spreaders', nl: 'Strooiers' },
  'Épandeurs d\'engrais': { en: 'Fertiliser spreaders', nl: 'Meststrooiers' },
  'Épandeurs de semences': { en: 'Seed spreaders', nl: 'Zaadstrooiers' },
  'Épandeurs à fumier': { en: 'Manure spreaders', nl: 'Meststrooiers' },
  'Équerres': { en: 'Squares', nl: 'Winkhaken' },
  'Équilibreuses': { en: 'Wheel balancers', nl: 'Bandbalanceermachines' },
  'Établis': { en: 'Workbenches', nl: 'Werkbanken' },
  'Étaux': { en: 'Vices', nl: 'Bankschroeven' },
  'Haies': { en: 'Hedges', nl: 'Hagen' },
  "Arbres d'ornement": { en: 'Ornamental trees', nl: 'Sierbomen' },
  'Arbres fruitiers': { en: 'Fruit trees', nl: 'Fruitbomen' },
  'Arbustes': { en: 'Shrubs', nl: 'Struiken' },
  'Conifères': { en: 'Conifers', nl: 'Coniferen' },
  'Vivaces & massifs': { en: 'Perennials & beds', nl: 'Vaste planten & borders' },
  'Plants forestiers': { en: 'Forestry plants', nl: 'Bosplantsoen' },
  'Gros sujets': { en: 'Specimen plants', nl: 'Grote exemplaren' },
  'Gazon & semences': { en: 'Turf & seed', nl: 'Gras & zaden' },
  'Terreaux & amendements': { en: 'Compost & soil improvers', nl: 'Potgrond & bodemverbeteraars' },
  'Paillage': { en: 'Mulch', nl: 'Mulch' },
  'Terre végétale': { en: 'Topsoil', nl: 'Teelaarde' },
  'Livraison végétaux': { en: 'Plant delivery', nl: 'Plantenlevering' },
  'Plantation': { en: 'Planting', nl: 'Aanplanting' },
  'Autres végétaux': { en: 'Other plants', nl: 'Andere planten' },
  'Gravillons': { en: 'Chippings', nl: 'Steenslag' },
  'Tout-venant': { en: 'All-in aggregate', nl: 'Menggranulaat' },
  'Géotextile': { en: 'Geotextile', nl: 'Geotextiel' },
  "Plantes d'intérieur": { en: 'Indoor plants', nl: 'Kamerplanten' },
  "Plantes d'extérieur": { en: 'Outdoor plants', nl: 'Buitenplanten' },
  'Plantes fruit, légumes & aromatiques': { en: 'Fruit, vegetable & herb plants', nl: 'Fruit-, groente- en kruidplanten' },
  'Engrais, terre de jardin & gazon': { en: 'Fertiliser, garden soil & turf', nl: 'Meststof, tuinaarde & gras' },
  'Potager & serres de jardin': { en: 'Kitchen garden & greenhouses', nl: 'Moestuin & serres' },
  'Poterie & jardinières': { en: 'Pottery & planters', nl: 'Potten & plantenbakken' },
  'Outils manuels de désherbage': { en: 'Manual weeding tools', nl: 'Handmatig wieden' },
  'Outils pour travailler le sol': { en: 'Soil-working tools', nl: 'Grondbewerkingsgereedschap' },
  "Outils de taillage & d'élagage": { en: 'Pruning & trimming tools', nl: 'Snoei- en trimgereedschap' },
  'Râteaux & balais à gazon': { en: 'Rakes & lawn brooms', nl: 'Harken & grasharken' },
  'Outils manuels pour entretien gazon': { en: 'Manual lawn-care tools', nl: 'Handmatig gazononderhoud' },
  'Haches & hachettes': { en: 'Axes & hatchets', nl: 'Bijlen & handbijlen' },
  'Désherbant': { en: 'Weed killer', nl: 'Onkruidverdelger' },
  'Scies à bûches & chevalet': { en: 'Log saws & sawhorse', nl: 'Blokzagen & zaagbok' },
  'Balais & brosses de jardin': { en: 'Garden brooms & brushes', nl: 'Tuinvegers & borstels' },
  'Nettoyeurs haute pression': { en: 'Pressure washers', nl: 'Hogedrukreinigers' },
  'Tondeuses à gazon': { en: 'Lawnmowers', nl: 'Grasmaaiers' },
  'Coupe-bordure motorisés': { en: 'Powered edgers', nl: 'Gemotoriseerde kantenmaaiers' },
  'Taille-haie motorisés': { en: 'Powered hedge trimmers', nl: 'Gemotoriseerde heggenscharen' },
  'Aspirateurs & souffleurs de feuilles': { en: 'Leaf vacuums & blowers', nl: 'Bladzuigers & -blazers' },
  'Scarificateurs motorisés': { en: 'Powered scarifiers', nl: 'Gemotoriseerde verticuteermachines' },
  "Tuyaux d'arrosage": { en: 'Garden hoses', nl: 'Tuinslangen' },
  'Dévidoirs & supports de tuyau': { en: 'Hose reels & holders', nl: 'Slanghaspels & -houders' },
  'Arroseurs automatiques': { en: 'Automatic sprinklers', nl: 'Automatische sproeiers' },
  "Pompes d'arrosage & pompes à eau": { en: 'Watering & water pumps', nl: 'Besproeiings- en waterpompen' },
  'Pulvérisateurs à main': { en: 'Hand sprayers', nl: 'Handsproeiers' },
  'Récupérateurs eau de pluie hors sol': { en: 'Above-ground rainwater tanks', nl: 'Bovengrondse regenwatertanks' },
  'Étangs de jardin': { en: 'Garden ponds', nl: 'Vijvers' },
  'Panneaux en bois': { en: 'Wooden panels', nl: 'Houten panelen' },
  'Poteaux clôture en bois': { en: 'Wooden fence posts', nl: 'Houten paalwerk' },
  'Bordures en bois': { en: 'Wooden edging', nl: 'Houten afboording' },
  'Lames de terrasse en bois': { en: 'Wooden decking boards', nl: 'Houten terrasplanken' },
  'Portes de jardin & portillons': { en: 'Garden doors & gates', nl: 'Tuindeuren & poortjes' },
  'Grillages': { en: 'Wire mesh', nl: 'Gaas' },
  'Occultation, brise-vue & canisses': { en: 'Screening & reed fencing', nl: 'Afscherming & rietmatten' },
  'Paravents de jardin': { en: 'Garden screens', nl: 'Tuinschermen' },
  'Dalles de jardin & caillebotis': { en: 'Garden slabs & deck tiles', nl: 'Tegels & vlonders' },
  'Graviers & galets': { en: 'Gravel & pebbles', nl: 'Grind & keien' },
  'Sable pour sol extérieur': { en: 'Outdoor sand', nl: 'Zand voor buiten' },
  'Pavé & clinkers': { en: 'Pavers & clinkers', nl: 'Klinkers' },
  'Gazon synthétique': { en: 'Artificial turf', nl: 'Kunstgras' },
  'Plinthes de terrasse': { en: 'Decking skirting', nl: 'Terrasplinten' },
  'Bordures de jardin': { en: 'Garden edging', nl: 'Tuinranden' },
  'Traitement mauvaises herbes & dépôt vert': { en: 'Weed & algae treatment', nl: 'Onkruid- & algenbehandeling' },
  'Traitement & protection contre les insectes': { en: 'Insect treatment & protection', nl: 'Insectenbehandeling & -bescherming' },
  'Protection contre les nuisibles': { en: 'Pest protection', nl: 'Ongediertebescherming' },
  'Protection culture & antiparasites': { en: 'Crop protection', nl: 'Gewasbescherming' },
  'Chape': { en: 'Screed', nl: 'Chape' },
  'Adjuvants béton': { en: 'Concrete admixtures', nl: 'Betonadditieven' },
  'Hourdis & linteaux': { en: 'Floor slabs & lintels', nl: 'Welfsels & lateien' },
  'Enduits de façade': { en: 'Facade renders', nl: 'Gevelpleisters' },
  'Hydrofuge & étanchéité maçonnerie': { en: 'Masonry waterproofing', nl: 'Waterdichting metselwerk' },
  'Tuiles': { en: 'Roof tiles', nl: 'Dakpannen' },
  'Ardoises': { en: 'Slates', nl: 'Leien' },
  'Zinc & métaux de toiture': { en: 'Zinc & roofing metals', nl: 'Zink & dakmetalen' },
  'Étanchéité toiture': { en: 'Roof waterproofing', nl: 'Dakdichting' },
  'Gouttières & descentes': { en: 'Gutters & downpipes', nl: 'Dakgoten & regenpijpen' },
  'Sous-toiture & écrans': { en: 'Underlay & roof screens', nl: 'Onderdak & schermen' },
  'Fenêtres de toit': { en: 'Roof windows', nl: 'Dakvensters' },
  'Isolation toiture': { en: 'Roof insulation', nl: 'Dakisolatie' },
  'Accessoires de couverture': { en: 'Roofing accessories', nl: 'Dakaccessoires' },
  'Tubes cuivre, PER & multicouche': { en: 'Copper, PER & multilayer pipes', nl: 'Koper, PER & meerlagenbuizen' },
  'Raccords & vannes': { en: 'Fittings & valves', nl: 'Fittingen & kranen' },
  'Évacuation & PVC': { en: 'Waste & PVC', nl: 'Afvoer & PVC' },
  'Sanitaire (WC, lavabos, douches)': { en: 'Sanitary ware', nl: 'Sanitair' },
  'Robinetterie': { en: 'Taps & mixers', nl: 'Kraanwerk' },
  'Ballons & chauffe-eau': { en: 'Cylinders & water heaters', nl: 'Boilers & geisers' },
  'Accessoires de plomberie': { en: 'Plumbing accessories', nl: 'Loodgietersaccessoires' },
  'Chaudières': { en: 'Boilers', nl: 'Ketels' },
  'Pompes à chaleur': { en: 'Heat pumps', nl: 'Warmtepompen' },
  'Radiateurs': { en: 'Radiators', nl: 'Radiatoren' },
  'Plancher chauffant': { en: 'Underfloor heating', nl: 'Vloerverwarming' },
  'Conduits & fumisterie': { en: 'Flues & chimneys', nl: 'Rookkanalen' },
  'Climatisation': { en: 'Air conditioning', nl: 'Airconditioning' },
  'Régulation & thermostats': { en: 'Controls & thermostats', nl: 'Regeling & thermostaten' },
  'Pellets & combustible': { en: 'Pellets & fuel', nl: 'Pellets & brandstof' },
  'Câbles & fils': { en: 'Cables & wires', nl: 'Kabels & draden' },
  'Tableaux & disjoncteurs': { en: 'Boards & breakers', nl: 'Borden & automaten' },
  'Prises, interrupteurs & goulottes': { en: 'Sockets, switches & trunking', nl: 'Stopcontacten, schakelaars & goten' },
  'Chemins de câbles': { en: 'Cable trays', nl: 'Kabelgoten' },
  'Domotique': { en: 'Home automation', nl: 'Domotica' },
  'Matériel photovoltaïque': { en: 'PV equipment', nl: 'PV-materiaal' },
  'Accessoires électricité': { en: 'Electrical accessories', nl: 'Elektriciteitsaccessoires' },
  'Parquets & stratifiés': { en: 'Parquet & laminate', nl: 'Parket & laminaat' },
  'Portes & huisseries': { en: 'Doors & frames', nl: 'Deuren & kozijnen' },
  'Fenêtres': { en: 'Windows', nl: 'Ramen' },
  'Escaliers & garde-corps': { en: 'Stairs & railings', nl: 'Trappen & leuningen' },
  'Quincaillerie de meuble': { en: 'Furniture hardware', nl: 'Meubelbeslag' },
  'Colles & abrasifs bois': { en: 'Wood glues & abrasives', nl: 'Houtlijm & schuurmiddelen' },
  'Électrodes & fils de soudure': { en: 'Welding electrodes & wire', nl: 'Laselektroden & -draad' },
  'Gaz de soudure': { en: 'Welding gases', nl: 'Lasgassen' },
  'Consommables de meulage': { en: 'Grinding consumables', nl: 'Slijpverbruik' },
  'Protection soudeur': { en: 'Welder protection', nl: 'Lassenbescherming' },
  'Accessoires de soudure': { en: 'Welding accessories', nl: 'Lasaccessoires' },
  'Plaques de plâtre': { en: 'Plasterboard', nl: 'Gipsplaten' },
  'Profilés placo': { en: 'Drywall profiles', nl: 'Gipsprofielen' },
  'Enduits plâtre': { en: 'Plaster compounds', nl: 'Gipspleisters' },
  'Membranes & étanchéité': { en: 'Membranes & waterproofing', nl: 'Membranen & dichting' },
  'Enduits de préparation': { en: 'Prep fillers', nl: 'Voorstrijkpleisters' },
  'Carrelage': { en: 'Tiles', nl: 'Tegels' },
  'Colles & joints carrelage': { en: 'Tile adhesives & grout', nl: 'Tegellijm & voeg' },
  'Revêtements de sol': { en: 'Floor coverings', nl: 'Vloerbekleding' },
  'Revêtements muraux': { en: 'Wall coverings', nl: 'Wandbekleding' },
  'Quincaillerie & fixations': { en: 'Hardware & fixings', nl: 'Ijzerwaren & bevestiging' },
  'Serrurerie & ferrures': { en: 'Locksmithing & ironmongery', nl: 'Sloten & beslag' },
  'Échafaudage': { en: 'Scaffolding', nl: 'Steigers' },
  'EPI & sécurité': { en: 'PPE & safety', nl: 'PBM & veiligheid' },
  'Signalisation de chantier': { en: 'Site signage', nl: 'Werfsignalisatie' },
  'Consommables atelier': { en: 'Workshop consumables', nl: 'Werkplaatsverbruik' },
  'Autres': { en: 'Other', nl: 'Overig' },
};

export default TAXONOMY_LABELS;
